export default {
    computed: {

        sourceOrderTypeList(){
            return[
                { value: 0, label: this.$t("erp.b2c.sale", { defaultValue: "销售" })},
                { value: 1, label: this.$t("erp.b2c.after_sales", {defaultValue: "售后"})},
                { value: 2, label:  this.$t("uc.global_catelog.v2_shipping", {defaultValue: "运单"})},
                ]
        },

        getLogisticStatus () {
            return [
                {
                    label: this.$t('fbb.expresspackage.logistic_status_unknown',{defaultValue:'未知'}),
                    value: 0
                },
                {
                    label: this.$t('fbb.expresspackage.logistic_status_printed',{defaultValue:'已打单'}),
                    value: 1
                },
                {
                    label: this.$t('fbb.expresspackage.logistic_status_scanned',{defaultValue:'已扫件'}),
                    value: 2
                },
                {
                    label: this.$t('fbb.expresspackage.logistic_status_outbound',{defaultValue:'已出库'}),
                    value: 3
                },
                {
                    label: this.$t('fbb.expresspackage.logistic_status_completed',{defaultValue:'已妥投'}),
                    value: 4
                },
                {
                    label: this.$t('fbb.expresspackage.logistic_status_arrived',{defaultValue:'已到达'}),
                    value: 5
                },
                {
                    label: this.$t('fbb.expresspackage.logistic_status_return',{defaultValue:'退回'}),
                    value: 6
                },
                {
                    label: this.$t('fbb.expresspackage.logistic_status_delivery_failed',{defaultValue:'投递失败'}),
                    value: 7
                },
                {
                    label: this.$t('fbb.expresspackage.logistic_status_cancelled',{defaultValue:'取消'}),
                    value: 8
                },
                {
                    label: this.$t('fbb.expresspackage.logistic_status_exception',{defaultValue:'异常'}),
                    value: 9
                }
            ]
        }
    }
}
